import { cn } from 'lib/utils'
import type React from 'react'
import { Input } from './input'
import { Label } from './label'
import { Select, type SelectOption } from './select'

type Value = { value: number | string; option: string }
export interface InputWithSelectProps {
  value: Value
  onChange?: (newValue: Value) => void
  options?: SelectOption[]
  className?: string
  label?: string
  placeholder?: string
  disabled?: boolean
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>
  prefix?: React.ReactNode
}

export const InputWithSelect: React.FC<InputWithSelectProps> = ({
  value,
  onChange,
  options,
  className,
  label,
  placeholder,
  disabled,
  inputProps = {
    type: 'number',
  },
  prefix,
}) => {
  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue =
      inputProps.type === 'number'
        ? e.target.value === ''
          ? NaN
          : Number(e.target.value)
        : e.target.value

    if (onChange) {
      onChange({ value: newValue, option: value.option })
    }
  }

  const handleUnitChange = (newUnit: string) => {
    if (onChange) {
      onChange({ value: value.value, option: newUnit })
    }
  }

  return (
    <div className={cn('flex flex-col', className)}>
      {label && <Label className="mb-2">{label}</Label>}
      <div className="relative flex items-center w-full border border-input rounded-md focus-within:ring-2 focus-within:ring-ring">
        {prefix && <div className="pl-3 text-primary text-p-400">{prefix}</div>}
        <Input
          {...inputProps}
          value={Number.isNaN(value.value) ? '' : value.value}
          onChange={handleValueChange}
          className={`w-full ${disabled ? 'bg-muted' : ''} placeholder:text-s-400`}
          variant="ghost"
          placeholder={placeholder}
          disabled={disabled}
        />
        <Select
          options={options ?? []}
          value={value.option}
          onChange={(newValue) => handleUnitChange(newValue as string)}
          className={`h-full w-28 ${disabled ? 'bg-muted' : ''}`}
          searchable={false}
          variant="ghost"
          disabled={disabled}
        />
      </div>
    </div>
  )
}

export default InputWithSelect
